import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { ActionTimeControl } from '../../ActionTimeControl/ActionTimeControl';
import { MoreVertIconContrast } from '../../../icons/MoreVertIconContrast';
import { getCurrentSendedLanding, getPreviewWorkTime } from '../../../selectors/sended-data';
import { Engine } from '../../../icons';
import { checkTimeIsCorrect } from '../../../service/NavPointsUtils';

export const StopEngineTime = memo(({ className, onShowModal, onChangeTime }) => {
    const { blockTime, value, timeEngineWorkAfter } = useSelector((state) => {
        const landing = getCurrentSendedLanding(state);
        const previewWorkTime = getPreviewWorkTime(state);

        return {
            value: landing.stopEngineTime,
            blockTime: previewWorkTime.blockTime,
            timeEngineWorkAfter: previewWorkTime.timeEngineWorkAfter,
        };
    }, shallowEqual);

    const { t: translate } = useTranslation();

    const stopEngineSummary = React.useMemo(() => {
        return [
            {
                title: translate('flightInfoPage.engineRunAfterLanding'),
                value: timeEngineWorkAfter,
                isCorrect: checkTimeIsCorrect(timeEngineWorkAfter),
            },
            {
                title: translate('flightInfoPage.blockTime'),
                value: blockTime,
                isCorrect: checkTimeIsCorrect(blockTime),
            },
        ];
    }, [timeEngineWorkAfter, blockTime, translate]);

    return (
        <ActionTimeControl
            title={translate('flightInfoPage.stopEngineTime')}
            buttonName={translate('flightInfoPage.stopEngine')}
            iconButton={<Engine width="30" height="30" />}
            iconMenuImg={<MoreVertIconContrast isContrast={true} />}
            text={translate('flightInfoPage.shutdownOn')}
            name="stopEngineTime"
            value={value}
            summary={stopEngineSummary}
            onChange={onChangeTime}
            showModal={onShowModal}
            className={className}
        />
    );
});
